module.exports = __webpack_public_path__ + "img/checked.4190ac11.svg";